import { createEffect, sample } from 'effector'

import { $portalProfile } from '@/entities/profile/portal'
import { acceptTerms, isTermsAccepted } from '@/features/terms'
import { isNotNull } from '@/shared/lib/types'

// automatically accept terms after successful login
sample({
    clock: $portalProfile,
    filter: isNotNull,
    target: createEffect(() => {
        if (!isTermsAccepted()) {
            acceptTerms()
        }
    }),
})
